<div class="importar-xml-etapa">
  <div class="section-container importar-xml-section-container">
    <div class="section-title">
      <mat-icon class="material-symbols-outlined">rule_settings</mat-icon>
      <span>Regras de associação dos itens/produtos</span>
      <button mat-button type="button" class="btn-section importar-xml-regras-restaurar" (click)="onRestaurarPadrao()">
        <mat-icon class="material-symbols-outlined">restart_alt</mat-icon>
        Restaurar padrão
      </button>
    </div>
    <p class="section-sub-title">Definem como os itens do XML serão relacionados ao seu cadastro.</p>

    <app-alert-card type="info" icon="info">As regras valem somente para esta importação.</app-alert-card>

    <span class="importar-xml-regras-titulo">Ordem de prioridade</span>
    <div class="importar-xml-regras-lista">
      @for (regra of regras; track regra.key; let i = $index) {
      <div class="importar-xml-regra-linha">
        <span class="importar-xml-regra-numero">{{ i + 1 }}</span>
        <mat-icon class="material-symbols-outlined">{{ regra.icon }}</mat-icon>
        <span class="importar-xml-regra-label">{{ regra.label }}</span>
        <button mat-icon-button type="button" [disabled]="i === 0" (click)="onMoverRegra(i, -1)">
          <mat-icon class="material-symbols-outlined">keyboard_arrow_up</mat-icon>
        </button>
        <button mat-icon-button type="button" [disabled]="i === regras.length - 1" (click)="onMoverRegra(i, 1)">
          <mat-icon class="material-symbols-outlined">keyboard_arrow_down</mat-icon>
        </button>
      </div>
      }
    </div>

    <span class="importar-xml-regras-titulo importar-xml-regras-titulo--fallback">Se nenhuma regra encontrar correspondência</span>
    <div class="importar-xml-toggle-descricao">
      <span class="importar-xml-toggle-descricao-texto">
        <mat-icon class="material-symbols-outlined">match_case</mat-icon>
        <span>Relacionar apenas pela descrição (requer revisão item a item)</span>
      </span>
      <mat-slide-toggle
        class="app-toggle-compact"
        [ngModel]="consideraApenasDescricao"
        (ngModelChange)="onToggleDescricaoChange($event)"
        aria-label="Relacionar apenas pela descrição">
      </mat-slide-toggle>
    </div>
    <div class="importar-xml-regras-sem-correspondencia">
      <mat-icon class="material-symbols-outlined">note_add</mat-icon>
      <span><strong>Sem nenhuma correspondência:</strong> o item seguirá para revisão na associação.</span>
    </div>
  </div>
</div>
